import { DEMO_SECTION_BK_PREFIX } from 'app/constants/demo-section.constant';

export function isDemoBK(bk) {
  return bk.search(DEMO_SECTION_BK_PREFIX) > -1;
}

export function extractBKFromDemo(bk) {
  return bk.startsWith(DEMO_SECTION_BK_PREFIX, '');
}
